/**
 * From the C64's screen coordinates (which the simulation keeps, see types.ts) to playfield
 * pixels (x right 0..255, y down 0..199), which the renderer turns into world units.
 */

/** Centre of a sprite's 16x16 body, in playfield pixels. */
export function spriteCentre(x: number, y: number): { x: number; y: number } {
  return { x: x - 20 + 8, y: y - 45 + 8 };
}

/** The point under a sprite's feet, in playfield pixels. */
export function spriteFeet(x: number, y: number): { x: number; y: number } {
  return { x: x - 20 + 8, y: y - 45 + 16 };
}
